import { SMRuleListItem } from '../../../integrated-client/models';

export type RuleListItemsList = Array<SMRuleListItem>;
export class ResultsData {

  ruleList: RuleListItemsList
  showMore: boolean

  constructor() {
    this.ruleList = [];
    this.showMore = false;
  }

}